(() => {
  const doc = document.documentElement;
  let state;
  try { state=JSON.parse(sessionStorage.getItem('pad-arrival')||'null');sessionStorage.removeItem('pad-arrival'); } catch(_) {}
  const clearFlags = () => doc.classList.remove('pad-arrival-pending','pad-arrival-running');
  if(!state || Date.now()-state.time>12000 || matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) { clearFlags();return; }
  let cover, mark, flight, reveal, heroReveal, safety;
  const cleanup = () => {
    clearTimeout(safety);flight?.cancel();reveal?.cancel();heroReveal?.cancel();cover?.remove();mark?.remove();clearFlags();
  };
  addEventListener('pagehide',cleanup,{once:true});
  addEventListener('pageshow',event=>{if(event.persisted)cleanup();});
  const start = async () => {
    const brand=document.querySelector('.pad-navigation-brand');
    const hero=document.querySelector('[data-pad-hero-photo]');
    if(!brand || !hero){cleanup();return;}
    try {
      const target=(brand.querySelector('canvas,img')||brand).getBoundingClientRect();
      const from={x:Number(state.x),y:Number(state.y),width:Number(state.width),height:Number(state.height)};
      if(!Object.values(from).every(Number.isFinite)||from.width<=0) {cleanup();return;}
      cover=document.createElement('div');cover.className='pad-arrival-cover';cover.setAttribute('aria-hidden','true');
      mark=document.createElement('img');mark.className='pad-arrival-poppy';mark.alt='';mark.src=state.source;
      Object.assign(mark.style,{left:`${from.x}px`,top:`${from.y}px`,width:`${from.width}px`,height:`${from.height}px`});
      document.body.append(cover,mark);
      safety=setTimeout(cleanup,2300);
      await Promise.race([mark.decode().catch(()=>{}),new Promise(resolve=>setTimeout(resolve,180))]);
      doc.classList.add('pad-arrival-running');doc.classList.remove('pad-arrival-pending');
      // Solid cream wipes upward as the exact landing frame settles into the header.
      // The cover exposes the entire hero progressively, without a transparency fade.
      const ease='cubic-bezier(.76,0,.24,1)';
      flight=mark.animate([
        {transform:'translate(0,0) scale(1)'},
        {transform:`translate(${target.x-from.x}px,${target.y-from.y}px) scale(${target.width/from.width},${target.height/from.height})`}
      ],{duration:1250,easing:ease,fill:'forwards'});
      heroReveal=hero.animate([{clipPath:'inset(12% 16% 12% 16%)'},{clipPath:'inset(0 0 0 0)'}],{duration:1250,easing:ease,fill:'forwards'});
      reveal=cover.animate([{clipPath:'inset(0 0 0 0)'},{clipPath:'inset(0 0 100% 0)'}],{duration:1150,delay:100,easing:ease,fill:'forwards'});
      await Promise.all([flight.finished,reveal.finished,heroReveal.finished]);
      cleanup();
    } catch(_) {cleanup();}
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
